import { render, staticRenderFns } from "./PatternPracticeForm.vue?vue&type=template&id=2cbcf702&"
import script from "./PatternPracticeForm.vue?vue&type=script&lang=js&"
export * from "./PatternPracticeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports